// Подключаемая вёрстка

export default ({ cls, data, id } = {}) => [
  {block: 'tabs', cls, mods: {flex: true}, content: [
      {elem: 'list', attrs: {role: 'tablist'}, content: [
          {elem: 'inner', content: data.map(({ title, target, active, tabAttrs }, idx) => {
              const targetId = target ? target : `#TABS_TARGET_${id}-${idx}`;
              return [
                {elem: 'item', cls: `${active || idx === 0 ? 'active' : ''}`, tag: 'button',
                  attrs: {'data-bs-toggle': 'tab', 'data-bs-target': targetId, type: 'button', ...tabAttrs},
                  content: title}
              ];
            })}
        ]},
    ]}
];
